angular.module('bmsApp.settings')
	.controller('OnlineEmailRedemptionCodeCtrl', OnlineEmailRedemptionCodeCtrl);

OnlineEmailRedemptionCodeCtrl.$inject = [
	'$scope',
	'$state',
	'$q',
	'$timeout',
	'notify',
	'LicenseOptionsSvc',
	'OnlineDiscountSvc',
];

function OnlineEmailRedemptionCodeCtrl($scope, $state, $q, $timeout, notify, LicenseOptionsSvc, OnlineDiscountSvc) {
	let self = this;
	let handlers = {};

	angular.extend(self, {
		loading: null,
		handlers: handlers,
		options: {},
		showForm: false,
		form: {
			license: null,
			discount_code: null,
		},
	});

	this.$onInit = () => {
		let promises = {
			licenses: LicenseOptionsSvc.license()
				.then((response) => {
					self.options.licenses = response.data.options;
				}),
		};
		$q.all(promises)
			.then((response) => {
				self.loading = false;
			});
	};

	// Handlers --------------------------------------------------------------------------------------------------------
	handlers.licenseChanged = () => {
		let promises = {
			discountCodes: OnlineDiscountSvc.options({
				filter: {
					license: self.form.license.id,
				},
			}),
			emailRedemptionCode: OnlineDiscountSvc.emailRedemptionCode(self.form.license.id),
		};
		$q.all(promises).then((responses) => {
			self.options.discountCodes = responses.discountCodes.data.options;
			self.form.discount_code = responses.emailRedemptionCode.data.discount_code;
			self.showForm = true;

		});
	};

	handlers.submitClick = function () {
		return OnlineDiscountSvc.setAsEmailRedemptionCode(self.form).then((response) => {
			notify({
				message: 'Email redemption code updated',
			});
		}, (errors) => {
			self.errors = errors;
		});
	};
}
